import { useSelector } from "react-redux";
import type { RootState } from "../../WebsiteStore";

export const useAppSelector = useSelector.withTypes<RootState>()
